import { useField } from 'formik';
import { Chips, ChipsOptionType } from '../Chips/Chips';
import { ReactNode } from 'react';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { ResponseErrorType } from '@/types/sharedTypes';

interface FormikChipsType {
  name: string;
  options: ChipsOptionType[];
  disabled?: boolean;
  label?: ReactNode;
  direction?: 'column' | 'row';
  apiError?: ResponseErrorType;
}

export const FormikChips = ({ label, name, options, disabled, direction, apiError }: FormikChipsType) => {
  const [field, meta, { setValue }] = useField(name);

  const { apiError: apiErrorMessage, error } = getFieldError(name, meta, apiError);

  const handleSelect = (value: string) => {
    setValue(value);
  };

  return (
    <Chips
      {...field}
      value={field.value}
      onSelect={handleSelect}
      options={options}
      disabled={disabled}
      label={label}
      direction={direction}
      error={error}
      apiError={apiErrorMessage}
    />
  );
};
